import { motion } from 'framer-motion';

interface CopilotAvatarProps {
  isLoading: boolean;
}

export const CopilotAvatar = ({ isLoading }: CopilotAvatarProps) => {
  const content = isLoading ? (
    <div className="relative flex items-center justify-center">
      {/* Pulsing glow background */}
      <motion.div
        className="bg-primary-400/50 absolute rounded-full blur-md"
        animate={{
          scale: [1, 1.5, 1],
          opacity: [0.5, 0.8, 0.5],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
        style={{ width: 40, height: 40 }}
      />

      {/* Scaling avatar */}
      <motion.img
        src="/copilot/loading_static.png"
        alt="Finny"
        className="relative z-10 h-8 w-8 rounded-full"
        animate={{
          scale: [0.8, 1.1, 0.8],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />
    </div>
  ) : (
    <img
      src="/copilot/loading_static.png"
      alt="Finny"
      className="h-8 w-8 rounded-full"
    />
  );

  return (
    <div className="flex items-center justify-center gap-2">{content}</div>
  );
};
